import React from 'react';

import Button from 'CommonComponents/Button';

/**
 * The dashboard's expanded empty state: headline, supporting line, and optionally
 * the two routes out of an empty plan. Both actions are gated on `canManage` — a
 * viewer who cannot edit the plan gets the explanation without the dead ends.
 *
 * Callers may omit the action props entirely to render explanation only. The
 * executive summary strip does exactly that: it is empty only when the event has
 * no projects, which is precisely when the cards below it are also empty and
 * already offer the same two actions.
 */
export default function ProjectDashboardEmptyState({ headline, supporting, canManage, onAddActivity, importProjectPlanUrl }) {
    return (
        <div className="tw-py-12 tw-px-4 tw-text-center">
            <p className="tw-text-base tw-font-medium tw-text-charcoal">{headline}</p>
            <p className="tw-mx-auto tw-mt-2 tw-max-w-md tw-text-sm tw-text-charcoal-50">{supporting}</p>
            {canManage && (
                <div className="tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-3">
                    <Button small variant="primary" onClick={onAddActivity}>
                        {$t('+ Add activity')}
                    </Button>
                    {importProjectPlanUrl && (
                        <Button small as="a" variant="secondary" href={importProjectPlanUrl}>
                            {$t('Import from Excel')}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
}
